function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "22.352",
  height: "22.351"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_3341",
  "data-name": "Rectangle 3341",
  fill: "#e8a100",
  d: "M0 0h22.352v22.351H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_7108",
  "data-name": "Group 7108"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7096",
  "data-name": "Group 7096",
  clipPath: "url(#clip-path)",
  fill: "#e8a100"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4234",
  "data-name": "Path 4234",
  d: "M11.176 0a11.175 11.175 0 1011.176 11.176A11.189 11.189 0 0011.176 0m0 20.051a8.876 8.876 0 118.875-8.875 8.885 8.885 0 01-8.875 8.875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4235",
  "data-name": "Path 4235",
  d: "M11.176 5.028A1.475 1.475 0 009.7 6.5v7.371a2.426 2.426 0 012.95 0V6.5a1.475 1.475 0 00-1.475-1.475"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4236",
  "data-name": "Path 4236",
  d: "M11.176 14.374a1.475 1.475 0 101.475 1.475 1.475 1.475 0 00-1.475-1.475"
})))));